// We only show a limited number of featured properties by default in the table layout.
// This determines how many we take (from the start of the list).
export const DEFAULT_PROPERTY_COLUMN_COUNT = 2;
